<template>
  <div>
    <b-row>
      <b-col
        cols="6"
        lg="3"
        v-for="(file, index) in files"
        :key="index"
        class="mb-2"
      >
        <div class="gid-file-selector__box">
          <div
            class="border rounded d-flex align-items-center justify-content-center p-2 gid-file-selector__image"
          >
            <template v-if="file.mimetype.startsWith('image/')">
              <img
                v-if="file.data"
                :src="`data:${file.mimetype};base64,${file.data}`"
                alt="GID"
                class="mw-100 mh-100"
              />
              <img
                v-else-if="file.path"
                :src="`/api/media/thumb/${file.path}?jwt=${access_token}`"
                alt="GID"
                class="mw-100 mh-100"
              />
            </template>
            <i
              v-else-if="file.mimetype == 'application/pdf'"
              class="display-4 text-primary material-icons"
            >
              picture_as_pdf
            </i>
            <i
              class="material-icons text-danger rounded-circle gid-file-selector__close"
              @click="removeFile(index)"
              v-if="!readonly"
            >
              remove_circle
            </i>
            <i
              v-if="file.resampled"
              class="material-icons rounded-circle text-warning gid-file-selector__resampled"
              v-b-tooltip.hover
              :title="$t('inputs.files.resampled')"
            >
              warning
            </i>
          </div>
        </div>
        <b-form-group v-if="comments" label="Comments:" class="mt-2 mb-0">
          <b-form-input v-model="file.comment" :readonly="readonly" />
        </b-form-group>
      </b-col>
      <b-col
        cols="6"
        lg="3"
        class="mb-2 gid-file-selector__add-box"
        v-if="canAdd"
      >
        <div
          class="border rounded d-flex align-items-center justify-content-center h-100 p-2"
        >
          <input
            class="gid-file-selector__add"
            type="file"
            @change="fileSelected"
            multiple
          />
          <i class="text-primary material-icons">library_add</i>
        </div>
      </b-col>
    </b-row>
    <b-alert show v-if="fileTypeError">
      {{ $t('inputs.files.type-not-supported') }}
    </b-alert>
  </div>
</template>

<script>
import BaseInput from './mixins/BaseInput';
import FilesSelectorMixin from './mixins/FilesSelectorMixin';

export default {
  mixins: [BaseInput, FilesSelectorMixin],
  props: {
    maxFiles: Number,
    resultAsArray: Boolean,
    comments: Boolean,
    variant: String,
  },
  data() {
    return {
      files: [],
      fileTypeError: false,
    };
  },
  watch: {
    files: {
      deep: true,
      handler() {
        const resultArray = this.files.map((file) => {
          const fileMap = file.id ? { id: file.id } : { data: file.data };
          fileMap.mimetype = file.mimetype;
          if (this.comments) {
            fileMap.comment = file.comment;
          }
          fileMap.name = file.name;
          fileMap.size = file.size;
          return fileMap;
        });
        const variant = this.variant || undefined;
        const returnValue =
          resultArray.length > 0 ? { files: resultArray, variant } : null;
        this.commitOrEmit(this.resultAsArray ? resultArray : returnValue);
      },
    },
  },
  computed: {
    canAdd() {
      if (this.readonly) return false;
      return !this.maxFiles || this.files.length < this.maxFiles;
    },
  },
};
</script>

<style lang="scss">
@import '../../scss/_file-selector.scss';
</style>
